import { apiGet, apiPost } from './client';

export function checkDuplicates(body) {
  return apiPost('/campaigns/check-duplicates', body);
}

export function createCampaign(body) {
  return apiPost('/campaigns', body);
}

export function listCampaigns() {
  return apiGet('/campaigns/list');
}

export function getCampaign(campaignId) {
  return apiGet(`/campaigns/${campaignId}`);
}

export function pauseCampaign(campaignId) {
  return apiPost(`/campaigns/${campaignId}/pause`);
}

export function resumeCampaign(campaignId) {
  return apiPost(`/campaigns/${campaignId}/resume`);
}

export function stopCampaign(campaignId) {
  return apiPost(`/campaigns/${campaignId}/stop`);
}

export function deleteCampaign(campaignId) {
  return apiPost(`/campaigns/${campaignId}/delete`);
}
